import { jsx as _jsx } from "react/jsx-runtime";
// frontend/src/components/AgentsBoard/OrgFilter.tsx
// Autocomplete has no @weave-mui equivalent — matches GithubReposEditor's existing precedent.
import { Autocomplete } from '@mui/material';
import { TextField } from '@weave-mui/material';
/** Default GitHub orgs otter-app is installed into — `freeSolo` still lets a user filter by an
 * org not in this list (e.g. a new org the app gets installed into later). */
export const DEFAULT_GIT_ORGS = [
    'https://git.autodesk.com/manufacturing-data-model',
    'https://git.autodesk.com/1f-components',
    'https://git.autodesk.com/fusion',
    'https://git.autodesk.com/A360Social',
];
export default function OrgFilter({ value, onChange, extraOptions }) {
    const options = Array.from(new Set([...DEFAULT_GIT_ORGS, ...extraOptions]));
    return (_jsx(Autocomplete, { freeSolo: true, size: "small", options: options, value: value, onChange: (_e, newValue) => onChange(newValue?.trim() || null), sx: { minWidth: 260 }, renderInput: (params) => (_jsx(TextField, { ...params, label: "GitHub org", placeholder: "All orgs", "aria-label": "Agent GitHub org filter" })) }));
}
